import DotPattern from "@/components/dot-pattern";
import DilemmaForm from "@/features/dilemmas/components/forms/dilemma-form";
import { useDilemmasFormStore } from "@/features/dilemmas/stores/useDilemmaFormStore";
import { useEffect } from "react";

const DilemmaCreatePage = () => {
  const reset = useDilemmasFormStore((s) => s.reset);

  useEffect(() => {
    return () => reset();
  }, [reset]);

  return (
    <div className="relative flex flex-col lg:flex-row gap-3 lg:gap-5 p-3 lg:p-6">
      <DotPattern />
      <DilemmaForm />
    </div>
  );
};

export default DilemmaCreatePage;
